import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EEntityType, ERelationType } from '@web/dtos';
import { TranslationTextAreaComponent } from '../../../../../components/data-input/form-inputs/translation-text-area/translation-text-area.component';
import { IFooterBlockForm } from '../../../../../entities/footer-entity';
import { CmsTextProviderService } from '../../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-footer-text-block-editor',
  imports: [ReactiveFormsModule, TranslationTextAreaComponent],
  templateUrl: './footer-text-block-editor.component.html',
})
export class FooterTextBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;
}
